/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { Navigate, useEffect, useState, useMemo } from "react";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import ScrollTopOnMount from "../../Layout/ScrollTopOnMount";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { getPageBySlug } from "../../../actions/auth";
import { Interweave } from "interweave";
import { CommonPageData } from '../../../styles/common.style';
import { FadeLoader } from "react-spinners";

const PrivatePages = ({ getPageBySlug, page }) => {
  let { slug } = useParams();
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  // Memoize user data to avoid repeated JSON parsing
  // TODO: Remove this line
  const userData = localStorage.getItem('user');

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await getPageBySlug(slug);
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  const handleRedirect = () => {
    if (page?.slug === "welcome-to-the-body-solutions-assessment") {
      if (!userData) {
        navigate('/signup');
      } else {
        navigate('/pages/assessment-info');
      }
    }
     else
      if (page?.slug === "assessment-info") {
      if (!userData) {
        navigate('/login');
      } else {
        navigate('/intake-form');
      }
    }
  }

  const pageContent = useMemo(() => {
    return (
      <>
        <ScrollTopOnMount />
        <Header />
        <div className={"clearfix"}></div>
        <CommonPageData>
          <section className={"recomended-products"}>
            {page?.slug !== "assessment-info" && (
              <div className='common-banner-block'>
                <div className='main-banner'>
                  <img src='/images/banner-common-block.png' alt='img' />
                </div>
                <div className='container'>
                  <div className='common-banner-block-inner'>
                    <h1 className="common-banner-block-inner-center">
                      {page ? page.name : ""}
                      <span className="sub-title">{page ? page.sub_title : ""}</span>
                    </h1>
                  </div>
                </div>
              </div>
            )}
            <Container>
              {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                  <FadeLoader color={'#FB1417'} loading={isLoading} />
                </div>
              ) : (
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className={"common-data-back-step-one"}>
                      {page?.slug === "assessment-info" ? (
                        <div className='image-cls'>
                          <Interweave
                            content={page ? page.content : "No Data Available"}
                            noHtml={false}
                            allowList={[
                              "iframe", "img", "video", "p", "a", "div",
                              "h1", "h2", "h3", "h4", "h5", "h6",
                              "ol", "ul", "li", "span"
                            ]}
                          />
                        </div>
                      ) : (
                        <div className='other-content-cls'>
                          <Interweave
                            content={page ? page.content : "No Data Available"}
                            noHtml={false}
                            allowList={[
                              "iframe", "img", "video", "p", "a", "div",
                              "h1", "h2", "h3", "h4", "h5", "h6",
                              "ol", "ul", "li", "span"
                            ]}
                          />
                        </div>
                      )}

                      {page?.is_button === 1 && (
                        <div className='btn-block-assesment'>
                          <button
                            className='theme-common-btn-big'
                            onClick={handleRedirect}
                            dangerouslySetInnerHTML={{ __html: page.button_text || "START ASSESSMENT" }}
                          />
                          {page?.slug === "welcome-to-the-body-solutions-assessment" && (
                            <div className='sign-in-link text-center mt-3'>
                              Already have an account? <NavLink className={'theme-red-color-text'} to={"/login"}>Sign In</NavLink>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            </Container>
          </section>

        </CommonPageData>
        <Footer />
      </>
    );
  }, [isLoading, page]);

  return pageContent;
};
const mapStateToProps = (state) => {
  return {
    page: state.auth.page,
  };
};
export default connect(mapStateToProps, { getPageBySlug })(PrivatePages);
